import { FC } from "react";
import { toDate } from "../../../../lib/date";
import { CellProps, Table } from "rsuite";
import { UserVehicleControl } from "../../../../domain/control/Vehicle";

export const VehicleControlTableTimestampCell: FC<
  CellProps<UserVehicleControl>
> = ({ rowData, ...props }) => {
  if (!rowData) {
    return null;
  }
  const { timestamp } = rowData;
  return (
    <Table.Cell {...props}>
      <span>{toDate(timestamp)}</span>
    </Table.Cell>
  );
};
